import React from 'react';
import Image from './image';
import { Link } from 'react-router-dom';
import './footer.css';

const Footer = (porps) => {
    let votingPolicyLink = '/pdf/voting-policy.pdf';
    return (
        <React.Fragment>
            <section className="container-fluid d-none">
                <div className=" pad-footer">
                    <div className="row justify-content-center">
                        <div className="col-md-6 ">
                            <div className="scrollTop"> {/*  onClick={topFunction()} */}
                                <p className="scroll-div"><span>
                                    <Image image="Top Button Arrow.png" />

                                </span></p>
                                <p className="scroll-txt">Scroll to top</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container-fluid footersec margin_redumption">
                <div className="row">

                    <div className="col-md-12 footer-small pad-footer pt-2 pb-2">
                        <div className="row  align-items-center ">
                            <div className="col-12 col-md-auto mr-auto "><p>CIN-U67120MH2008PLC188186 </p></div>
                            <div className="col-12 col-md-auto ">
                                <ul className="subFooter-list">
                                    <li><a href="/disclaimer">Disclaimer</a></li>
                                    <li><a href="/privacy-policy">Privacy Policy</a></li>
                                    <li><a href={votingPolicyLink}>Voting Policy</a></li>
                                    <li><a href="/sitemap">Sitemap</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 pad-footer pt-3 pb-4 ">
                        <div className="row footer-copywrite align-items-center ">
                            <div className="col-auto mr-auto "><p>© Copyright </p></div>
                            <div className="col-auto"><p>Site best viewed in Google Chrome (Latest version), Firefox (Latest version), Safari (Latest version), Microsoft Edge(Latest version)</p></div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment >
    )
}

export default Footer